import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as _ from "lodash";
import ActivityLogItem from "./ActivityLogItem";
import Divider from "@material-ui/core/Divider";

function ActivityLogModal(props){

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth={false} maxWidth={"md"} className={"activity-log-modal"}>
      <div className="flex items-center between-xs w-full">
        <p className="medium-text font-bold">Actvity Log</p>
        <FontAwesomeIcon icon="times" size="lg" className="text-grey cursor-pointer" onClick={props.onClose}/>
      </div>
      <Divider className="top-spacer-medium"/>
      <div className={"activity-log-container"}>
        {
          _.map(props.activityLog, (activity, i) => <ActivityLogItem key={i} activity={activity}/>)
        }
      </div>
    </Dialog>
  );
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default ActivityLogModal;